import React, { useState, useRef, useEffect, useContext } from "react";
import { Container, Row, Col, Navbar, Nav, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./NavSearch.css";
import logo from "../../../image/logo2.png";
import imageslider from "../../image/imageslider.png";
import Select, { components } from "react-select";
import ServiceMember from "../../../Member/Services/ServiceMember";
import {
  formatVilleToLabelValue,
  formatSecteurToLabelValue,
} from "../../../utils/utils";
import ServiceMedecin from "../Services/ServicesSearch";
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Divider from "@material-ui/core/Divider";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";
import avatar from "../../image/avatar.png";
import { MedecinContext, VilleContext, SecteurContext } from "../../../App";
import AuthService from "../../../Login/Services/auth.service";
import NavBar from "../../../Member/Navbar/Navbar";
const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: "36ch",
    backgroundColor: theme.palette.background.paper,
  },
  inline: {
    display: "inline",
  },
}));
const SingleValue = ({ children, ...props }) => (
  <components.SingleValue {...props}>{children}</components.SingleValue>
);
function NavSearch() {
  const [formattedVille, setFormattedVille] = useState();
  const [city, setCity] = useState("");
  const { listMedecin, setListMedecin } = useContext(MedecinContext);
  const { ville, setVille } = useContext(VilleContext);
  const { secteur, setSecteur } = useContext(SecteurContext);

  //  search
  const [display, setDisplay] = useState(false);
  const [options, setOptions] = useState([]);
  const [medecin, setMedecin] = useState(listMedecin);

  const wrapperRef = useRef(null);
  useEffect(() => {
    GetMedecin();
    // const pokemon = [
    //   { name: "fadili" },
    //   { name: "zakariya" },
    //   { name: "ilyass" },
    //   { name: "ibtissam" },
    //   { name: "fadili2" },
    //   { name: "zakariya2" },
    //   { name: "ilyass2" },
    //   { name: "ibtissam2" },
    // ];
    // setOptions(pokemon);
  }, []);

  useEffect(() => {
    window.addEventListener("mousedown", handleClickOutside);
    return () => {
      window.removeEventListener("mousedown", handleClickOutside);
    };
  });

  const handleClickOutside = (event) => {
    const { current: wrap } = wrapperRef;
    if (wrap && !wrap.contains(event.target)) {
      setDisplay(false);
    }
  };

  const updatePokeDex = (poke) => {
    setMedecin(poke);
    setDisplay(false);
  };
  //   card in material ui
  const classes = useStyles();

  // Get Data Medecin
  const GetMedecin = () => {
    ServiceMedecin.getMedecin().then((res) => {
      setOptions(res.data);
    });
  };

  const GetVille = () => {
    ServiceMember.getVille().then((res) => {
      setFormattedVille(res.data.map(formatVilleToLabelValue));
    });
  };
  useEffect(() => {
    GetVille();
  }, []);

  console.log("this is search ", city, medecin);

  const HandleSearch = (e) => {
    // ServiceMedecin.searchMedecin(medecin, city).then((res) => {
    //   // window.location.reload();
    //   // window.location.replace("/");

    //   console.log("this is XXXX", res.data);
    // });
    setListMedecin(medecin);
    setVille(city);
    setSecteur(secteurSearch);
  };

  // check  user
  const [currentUser, setCurrentUser] = useState(undefined);
  //super admin
  const [showSuperAdmin, setShowSuperAdmin] = useState(false);
  const [showAdmin, setShowAdmin] = useState(false);
  const [showMember, setShowMember] = useState(false);

  useEffect(() => {
    const user = AuthService.getCurrentUser();
    if (user) {
      setCurrentUser(user);
      setShowMember(user.role.includes("MEMBRE"));
      setShowAdmin(user.role.includes("ADMIN"));
      setShowSuperAdmin(user.role.includes("SUPER_ADMIN"));
    }
  }, []);
  // secteur
  const [formattedSecteur, setFormattedSecteur] = useState();
  const [secteurSearch, setSecteurSearch] = useState("");
  const [checkSecteur, setCheckSecteur] = useState(false);
  const onChangeVille = (formattedville) => {
    if (formattedville) {
      setCity({
        id: formattedville.value,
        designation: formattedville.label,
      });
      ServiceMember.getSecteur(formattedville.value).then((res) => {
        setFormattedSecteur(res.data.map(formatSecteurToLabelValue));
        setCheckSecteur(true);
      });
    } else {
      setCity("");
    }
  };
  const selectRef = useRef("");
  const clearCity = () => {
    setCity("");
    selectRef.current.select.clearValue();
  };
  console.log("secteur", secteur);
  return (
    <>
      <div>
        <div id="header-holder" className="inner-header">
          {showMember ? (
            <NavBar />
          ) : (
            <Container>
              <Navbar expand="lg">
                <Nav className="ml-auto navbar-nav">
                  <li className="mt-3">
                    <Link to="/pagehomeadmin">
                      Vous étes professionnel de santé?{" "}
                    </Link>
                  </li>
                  <li className="mt-3">
                    <Link
                      to={
                        currentUser && currentUser.role == "ADMIN"
                          ? "/formcarander"
                          : currentUser == "MEMBRE"
                          ? "/"
                          : "/login"
                      }
                    >
                      Connexion / Inscription
                    </Link>
                  </li>
                </Nav>
              </Navbar>
            </Container>
          )}

          <div className="container">
            <div className="row">
              <div className="col-md-6 text-center">
                <img src={logo} width="200px" className="mt-4" alt="" />
                <h4>Rendez vous avec vos professionnels de santé</h4>
              </div>
              <div className="col-md-6 text-center imgSlider">
                <img src={imageslider} width="55%" />
              </div>
            </div>
          </div>
        </div>

        <div className="container search mb-4">
          <Row className="justify-content-md-center">
            <Col className="mb-2" lg={4} sm={12}>
              <div
                ref={wrapperRef}
                className="flex-container flex-column pos-rel"
              >
                <div className="box" style={{ width: "100%" }}>
                  <i className="fa fa-search" aria-hidden="true"></i>
                  <input
                    id="auto"
                    // onClick={() => setDisplay(!display)}
                    type="text"
                    placeholder="Médecin, établissement, spécialité…"
                    value={medecin}
                    autoComplete="off"
                    onChange={(event) => {
                      setDisplay(event.target.value === "" ? false : true);
                      setMedecin(event.target.value);
                    }}
                  />
                </div>
                {display && (
                  <div className="autoContainer">
                    {options
                      .filter((i) => {
                        return (
                          i.firstName.toLowerCase().match(medecin) ||
                          i.lastName.toLowerCase().match(medecin) ||
                          (i.speciality &&
                            i.speciality.designation
                              .toLowerCase()
                              .match(medecin)) ||
                          i.adresse.toLowerCase().match(medecin)
                        );
                      })
                      .map((value, i) => {
                        return (
                          <div
                            onClick={() =>
                              updatePokeDex(
                                `${value.firstName} ${value.lastName}`
                              )
                            }
                            className="option"
                            key={i}
                            tabIndex="0"
                          >
                            <List className={classes.root}>
                              <ListItem alignItems="flex-start">
                                <ListItemAvatar>
                                  <Avatar alt="Cindy Baker" src={avatar} />
                                </ListItemAvatar>
                                <ListItemText
                                  primary={`${value.firstName} ${
                                    value.lastName
                                  } - ${
                                    value.speciality
                                      ? value.speciality.designation
                                      : "Laboratoire"
                                  } -`}
                                  secondary={
                                    <React.Fragment>
                                      {value.adresse}
                                    </React.Fragment>
                                  }
                                />
                              </ListItem>
                              <Divider variant="inset" component="li" />
                            </List>
                          </div>
                        );
                      })}
                  </div>
                )}
              </div>
            </Col>
            <Col className="mb-2" lg={3} sm={12}>
              <div className="box selectS" style={{ width: "100%" }}>
                <i className="fas fa-map-marker-alt"></i>
                <Select
                  placeholder="Où ?"
                  ref={selectRef}
                  isClearable
                  className="citysearch"
                  styles={{
                    singleValue: (base) => ({
                      ...base,
                      padding: 5,
                      borderRadius: 5,
                      //   background: "#0097e6",
                      color: "black",
                      display: "flex",
                    }),
                  }}
                  components={{ SingleValue }}
                  isSearchable
                  // isClearable
                  name="label"
                  options={formattedVille}
                  onChange={(formattedVille) => onChangeVille(formattedVille)}
                />
              </div>
            </Col>
            {checkSecteur && (
              <Col className="mb-2" lg={3} sm={12}>
                <div className="box selectS" style={{ width: "100%" }}>
                  <i className="fas fa-map-marker-alt"></i>
                  <Select
                    ref={selectRef}
                    isClearable
                    placeholder="Secteur"
                    width="90%"
                    className="citysearch"
                    styles={{
                      singleValue: (base) => ({
                        ...base,
                        padding: 5,
                        borderRadius: 5,
                        //   background: "#0097e6",
                        color: "black",
                        display: "flex",
                      }),
                    }}
                    components={{ SingleValue }}
                    isSearchable
                    name="label"
                    options={formattedSecteur}
                    onChange={(formattedSecteur) => {
                      if (formattedSecteur) {
                        setSecteurSearch({
                          id: formattedSecteur.value,
                          designation: formattedSecteur.label,
                        });
                      } else {
                        setSecteurSearch("");
                      }
                    }}
                  />
                </div>
              </Col>
            )}

            <Col className="mb-2" lg={2} sm={12}>
              <Link
                style={{
                  textDecoration: "none",
                }}
                to="/userdetails"
              >
                <Button
                  className="info btnS"
                  style={{
                    fontSize: "large",
                    backgroundColor: "#0596de",
                    margin: "auto",
                    display: "flex",
                  }}
                  onClick={() => HandleSearch()}
                  // disabled={medecin || city ? false : true}
                >
                  Rechercher
                </Button>
              </Link>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
}

export default NavSearch;
